export default __webpack_public_path__ + "static/media/pending_order.595f73e4.mp3";